import React from 'react'

export default function SocialLogs() {
    return (
        <>
            <li className="px-2">
                <a href="www.google.com">
                    <i className="fab fa-facebook"></i>
                </a>
            </li>
            <li className="px-2">
                <a href="www.face.com">
                    <i className="fab fa-twitter"></i>
                </a>
            </li>
            <li className="px-2">
                <a href="www.google.com">
                    <i className="fab fa-instagram"></i>
                </a>
            </li>
        </>
    )
}
